module.exports = __webpack_public_path__ + "img/huaxia_icon_active.6514a339.png";